<template>
  <v-card height="250px">
    <v-container fluid>
      <v-row no-gutters>
        <v-col>
          <h2 class="title">Top actual de equipos en servicio taller</h2>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row justify="end" class="pa-0 ma-0">
        <v-col cols="12" class="pa-0 ma-0">
          <!-- <v-overflow-btn
            v-if="true"
            append-icon="arrow_drop_down"
            class="pa-0 ma-0 overflow-select-text"
            dense
            flat
            v-model="orderBy"
            color="accent"
            label="MAYOR A MENOR PORCENTAJE DE SERVICIO"
            height="16"
            @change="orderByPercentage(orderBy)"
            :items="[
              {
                text: 'MAYOR A MENOR PORCENTAJE DE SERVICIO',
                value: 'percentageDesc'
              },
              {
                text: 'MENOR A MAYOR PORCENTAJE DE SERVICIO',
                value: 'percentageAsc'
              }
            ]"
          ></v-overflow-btn>
          -->
          <div class="filter font-weight-light">
            MAYOR A MENOR PORCENTAJE DE SERVICIO
          </div>
        </v-col>
      </v-row>
      <v-row no-gutters class="pa-0 ma-0">
        <v-col class="pa-0 ma-0">
          <v-simple-table height="170" dense>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="pa-0 text-center caption">Modelo</th>
                  <th class="pa-0 text-center caption">Top</th>
                  <th class="pa-0 text-center caption">%</th>
                  <th class="pa-0 text-center caption">EQ</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(product, index) in productsOnServiceTop"
                  :key="index"
                  class="text-left"
                >
                  <td class="pa-0 font-weight-light">{{ product.model }}</td>
                  <td class="pa-0 font-weight-light text-center">
                    {{ index + 1 }}
                  </td>
                  <td class="red--text pa-0 font-weight-light text-center">
                    {{ product.percentage }}%
                  </td>
                  <td class="red--text pa-0 font-weight-medium text-center">
                    {{ product.eq }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
  data() {
    return {
      orderBy: {
        text: "MAYOR A MENOR PORCENTAJE DE SERVICIO",
        value: "percentageDesc"
      }
    };
  },
  mounted() {
    if (this.$route.params.branchOffice) {
      this.getTopProductsInService(this.$route.params.branchOffice);
    } else {
      this.getTopProductsInService();
    }
  },
  computed: {
    ...mapState("machines", ["productsOnServiceTop"])
  },
  methods: {
    ...mapActions("machines", [
      "percentageAsc",
      "percentageDesc",
      "getTopProductsInService"
    ]),
    orderByPercentage(orderBy) {
      switch (orderBy) {
        case "percentageDesc":
          this.percentageDesc();
          break;
        case "percentageAsc":
          this.percentageAsc();
          break;
        default:
          break;
      }
    }
  },
  watch: {
    "$route.params.branchOffice": {
      handler: function(branch) {
        if (branch) {
          this.getTopProductsInService(branch);
        } else {
          this.getTopProductsInService();
        }
      },
      deep: true,
      immediate: true
    }
  }
};
</script>
<style lang="css" scoped>
.title {
  font-weight: 400 !important;
  color: black;
  font-size: 16px !important;
}
thead th {
  text-transform: uppercase;
  font-weight: 400;
  text-align: left;
  font-size: 17px !important;
  letter-spacing: 0;
  color: #808080;
  opacity: 1;
}
tbody td {
  color: #808080;
}
.filter {
  text-align: right;
  font-size: 12px;
  letter-spacing: 0;
  color: #808080;
  opacity: 1;
}
</style>
